import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldTeamUsersVariables = Types.Exact<{
  worldId: Types.Scalars['Int'];
}>;


export type ApiWorldTeamUsers = { worldTeamUsers: Array<{ name: string | null, username: string | null, profileImageUrl: string | null, role: Types.ApiWorldRole, publicKey: Address }> };



export const ApiworldTeamUsersDocument = /*#__PURE__*/ `
    query worldTeamUsers($worldId: Int!) {
  worldTeamUsers(worldId: $worldId) {
    publicKey: accountAddress
    name
    username
    profileImageUrl
    role
  }
}
    `;

export const useWorldTeamUsers = <
      TData = ApiWorldTeamUsers,
      TError = ClientError
    >(
      variables: ApiWorldTeamUsersVariables,
      options?: Omit<UseQueryOptions<ApiWorldTeamUsers, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldTeamUsers, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldTeamUsers, TError, TData>(
      {
    queryKey: ['worldTeamUsers', variables],
    queryFn: apiFetcher<ApiWorldTeamUsers, ApiWorldTeamUsersVariables>(ApiworldTeamUsersDocument, variables),
    ...options
  }
    )};

useWorldTeamUsers.getKey = (variables: ApiWorldTeamUsersVariables) => ['worldTeamUsers', variables];

export const useInfiniteWorldTeamUsers = <
      TData = InfiniteData<ApiWorldTeamUsers>,
      TError = ClientError
    >(
      variables: ApiWorldTeamUsersVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldTeamUsers, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldTeamUsers, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldTeamUsers, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['worldTeamUsers.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldTeamUsers, ApiWorldTeamUsersVariables>(ApiworldTeamUsersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldTeamUsers.getKey = (variables: ApiWorldTeamUsersVariables) => ['worldTeamUsers.infinite', variables];


useWorldTeamUsers.fetcher = (variables: ApiWorldTeamUsersVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldTeamUsers, ApiWorldTeamUsersVariables>(ApiworldTeamUsersDocument, variables, options);
